import customConfig from 'customConfig'

const rewardIcon = () => {
  return customConfig.coinIcon
}

export default rewardIcon
